import { createStore } from 'react-hookstore'
import JsonKeySort from 'json-keys-sort'
import axios from 'axios'
import React from 'react'
import { notification, Icon } from 'antd'

import { ENTRIES_URL, APPS, ENVS, ENVS_URL } from 'services/constants'
import { LU_API_ENDPOINT, LU_AUTH_TOKEN, ENTRIES } from 'services/constants'

const initialDiffer = {
  entry: ENTRIES_URL.ALL,
  app: APPS.NLU,
  env: '',
  loading: false
}
export const initialInfos = {
  left: undefined,
  right: undefined
}

export const toEnvPair = (env) => {
  let pair = []
  Object.keys(ENVS_URL).forEach(key => {
    if (ENVS_URL[key] === env) {
      const keys = key.split('_')
      const left = ENVS[keys[0]]
      const right = ENVS[keys[1]]
      pair = [left, right]
    }
  })
  console.log(pair)
  return pair
}

// function needRefetch(state) {
//   if (!!state.entry && !!state.app && !!state.envLeft && !!state.envRight) {
//     // TODO refetch
//   }
// }

function formatData(data) {
  return JsonKeySort.sort(data, true)
}

export const initStore = () => {
  createStore(
    'infosStore', 
    initialInfos,
    (state, action) => {
      // console.log(action, action.type)
      switch (action.type) {
        case 'update':
          let items = {}
          if (!!action.payload.left) {
            items.left = formatData(action.payload.left)
          }
          if (!!action.payload.right) {
            items.right = formatData(action.payload.right)
          }
          return Object.assign({}, state, items)
        case 'reset':
          return {
            left: initialInfos.left,
            right: initialInfos.right
          }
        default:
          return state
      }
    }
  )
  createStore(
    'differStore', 
    initialDiffer, 
    (state, action) => {
      switch (action.type) {
        case 'updateOptions':
          let nextState = {}
          Object.assign(nextState, state, action.payload)
          return nextState
        case 'load':
          return Object.assign({}, state, { loading: true })
        case 'loaded':
          return Object.assign({}, state, { loading: false })
        default:
          return state
      }

    }
  )
}

const fetchData = (entry, app, env, successCallback, errorCallback) => {
  const url = `${LU_API_ENDPOINT}/${entry}`
  const bearer = `Bearer ${LU_AUTH_TOKEN}`
  axios
    .get(url, {
      params: {
        'appName': app,
        'env': env
      },
      headers: {
        'Authorization': bearer
      }
    })
    .then(function (response) {
      if (!!response.data.code) {
        errorCallback(response.data)
      } else {
        successCallback(response.data)
      }
    })
    .catch(function (error) {
      // even failed to fetch data, serve error message 
      // to avoid nothing is displayed
      successCallback({'ERROR':error.response})
      errorCallback(error)
    })
}

const countToDispatchToInfos = (counter, total, nextInfos, dispatchToInfos, dispatchToDiffer) => {
  counter.value ++
  if (counter.value === total) {
    dispatchToInfos({
      type: 'update',
      payload: {
        left: nextInfos.allLeft,
        right: nextInfos.allRight
      }
    })
    dispatchToDiffer({type:'loaded'})
  }
}

const notifyFetchDataError = (entry, app, env) => {
  notification.open({
    message: '获取数据失败',
    description: `[接口]${entry} [应用]${app} [环境]${env}`,
    icon: <Icon type="frown" style={{ color: '#108ee9' }} />,
  })
}

export function fetchInfos(differ, dispatchToDiffer, dispatchToInfos) {
  dispatchToDiffer({type: 'load'})

  const { entry, app, env } = differ
  const envPair = toEnvPair(env)

  if (entry === ENTRIES_URL.ALL) {
    const [allLeft, allRight] = [{}, {}]
    const nextInfos = {allLeft, allRight}
    const counter = {value:0}
    const total = Object.keys(ENTRIES).length * 2
    for (const entry of Object.values(ENTRIES)) {
      for (const [index, env] of envPair.entries()) {
        fetchData(entry, app, env,
          (data) => {
            index ? (allRight[`${entry}`] = data) : (allLeft[`${entry}`] = data)
            countToDispatchToInfos(counter, total, nextInfos, dispatchToInfos, dispatchToDiffer)
          },
          (_data) => {
            notifyFetchDataError(entry, app, env)
            dispatchToDiffer({type:'loaded'})
          }
        )
      }
    }
  } else {
    const [envLeft, envRight] = envPair
    fetchData(entry, app, envLeft,
      (data) => {
        dispatchToInfos({
          type: 'update',
          payload: {
            left: data
          }
        })
        dispatchToDiffer({type:'loaded'})
      },
      (_data) => {
        notifyFetchDataError(entry, app, env)
        dispatchToDiffer({type:'loaded'})
      }
    )
    fetchData(entry, app, envRight,
      (data) => {
        dispatchToInfos({
          type: 'update',
          payload: {
            right: data
          }
        })
        dispatchToDiffer({type:'loaded'})
      },
      (_data) => {
        notifyFetchDataError(entry, app, env)
        dispatchToDiffer({type:'loaded'})
      }
    )
  }
}
